export enum OrganismeFichierProjection {
  DEFAULT = 'DEFAULT',
  LIGHT = 'LIGHT',
  INSCRIPTION = 'INSCRIPTION',
}